import 'css-chunk:src/tabs/tabs.module.scss';export default {
  "heading-xxl": "tabs-module__heading-xxl___2NIbc",
  "wrapper": "tabs-module__wrapper___bRnkm",
  "heading-xl": "tabs-module__heading-xl___B23y4",
  "heading-lg": "tabs-module__heading-lg___2WpfZ",
  "heading-md": "tabs-module__heading-md___LRmO3",
  "heading-sm": "tabs-module__heading-sm___iXfWn",
  "heading-xs": "tabs-module__heading-xs___TTil1",
  "body-one": "tabs-module__body-one___mE3BS",
  "body-two": "tabs-module__body-two___5suY-",
  "body-three": "tabs-module__body-three___LMfKI",
  "body-four": "tabs-module__body-four___vepqu",
  "overline-one": "tabs-module__overline-one___3xXOn",
  "overline-two": "tabs-module__overline-two___ZISxj",
  "overline-three": "tabs-module__overline-three___BvGqt",
  "strong": "tabs-module__strong___-86cT",
  "em": "tabs-module__em___mBh7b",
  "figcaption": "tabs-module__figcaption___WcNog",
  "no-margin": "tabs-module__no-margin___51BIq",
  "tabs": "tabs-module__tabs___4BiXZ",
  "tabs-primary": "tabs-module__tabs-primary___IIP8W",
  "tabs-light": "tabs-module__tabs-light___fw3pw",
  "selectedTab": "tabs-module__selectedTab___VTozz",
  "tabs-dark": "tabs-module__tabs-dark___T-1M-",
  "tabs-secondary": "tabs-module__tabs-secondary___4n5RT",
  "tabs-_tabGroup": "tabs-module__tabs-_tabGroup___hhqjJ",
  "tabs-l": "tabs-module__tabs-l___eV7tL",
  "iconOnlyTab": "tabs-module__iconOnlyTab___HVnWX",
  "tabs-m": "tabs-module__tabs-m___pR394",
  "tabs-s": "tabs-module__tabs-s___zxPLR",
  "tabs-xs": "tabs-module__tabs-xs___fXdAy"
};